import { render, staticRenderFns } from "./withdrawRecordList.vue?vue&type=template&id=caa88188&scoped=true"
import script from "./withdrawRecordList.vue?vue&type=script&lang=js"
export * from "./withdrawRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa88188",
  null
  
)

export default component.exports